import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DataSourceRequestState, toDataSourceRequestString } from '@progress/kendo-data-query';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Headers': 'Content-Type',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
  })
};
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  ipAddress: string = '';

  constructor(private _http: HttpClient) { }


  getClientData() {
    return this._http.get<any>(`${environment.endPoint}/api/Company/Get`);
  }

  getForAdmin() {
    return this._http.get<any>(`${environment.endPoint}/api/Company/GetForAdmin`);
  }
  getAllTransactions() {
    let token = localStorage['token'];
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this._http.get<any>(`${environment.endPoint}/api/Transactions/GetAllTransaction`, {
      headers: httpHeaders
    });
  }
  getAppointmentAndPatentCountByMonth(data: any) {
    return this._http.get<any>(`${environment.endPoint}/api/Admin/GetAppointmentAndPatentCountByMonth?year=${data}`);
  }

  editClientData(data: any) {
    return this._http.post(`${environment.endPoint}/api/Company/Update`, data);
  }
  updateForAdmin(data: any) {
    return this._http.post(`${environment.endPoint}/api/Company/UpdateForAdmin`, data);
  }
  deleteClientData(data: any) {
    return this._http.delete(`${environment.endPoint}/api/Company/Delete?id=${data}`,);
  }

  runMigrationData(data: any) {
    return this._http.post(`${environment.endPoint}/api/Admin/AdminMigrationById?companyid=${data}`, data);
  }

  login(data: any) {
    return this._http.post(`${environment.endPoint}/api/Admin/AdminLogin`, data);
  }
  changePass(data: any) {
    return this._http.post(`${environment.endPoint}/api/Admin/Changepassword`, data);
  }
  updateProfile(data: any) {
    return this._http.post(`${environment.endPoint}/api/Admin/UpdateAdminProfile`, data);
  }
  getAllUsers() {
    return this._http.get(`${environment.endPoint}/api/Admin/getAllUsers`);
  }
  updateUserStatus(id: number, status: boolean) {
    return this._http.get(`${environment.endPoint}/api/Admin/updateUserStatus?id=${id}&status=${status}`);
  }
  saveUser(data: any) {
    return this._http.post(`${environment.endPoint}/api/Admin/saveUser`, data);
  }
  UpdatePassword(data: any) {
    return this._http.post(`${environment.endPoint}/api/Admin/updatePassword`, data);
  }
  deleteUser(id: number) {
    return this._http.get(`${environment.endPoint}/api/Admin/deleteUser?id=${id}`);
  }
  getActiveClient() {
    return this._http.get<any>(`${environment.endPoint}/api/Company/GetActiveAndNonActiveCount`);
  }

  addMigration() {
    return this._http.post(`${environment.endPoint}/api/Admin/AdminMigration`, null);
  }

  AdminLoginData(data: any, domain: any) {
    if (domain != '') {
      localStorage.setItem('DomainUrl', domain);
    }
    else {
      localStorage.removeItem('DomainUrl');
    }
    return this._http.post(`${environment.endPoint}/api/User/LoginForAdmin?Id=${data}`, data);
  }

  getDefaultLocation(userId: any) {
    var requestUrl = localStorage.getItem("DomainUrl");
    var token = localStorage['token'];
    let locationId = JSON.parse(localStorage['Location'] == undefined ? null : localStorage['Location']);
    let companyid = localStorage['companyId'];
    var ipAddress = localStorage.getItem('IA')
    //  let httpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'X-Forwarded-For': `${ipAddress}`,
      'RequestUrl': requestUrl ? requestUrl : " "
    });
    let params = new HttpParams().set("companyId", companyid).set("locationId", (locationId || {}).id);

    return this._http.get(`${environment.endPoint}/api/SelectedLocation/GetByUserId?userId=${userId}`,
      {
        headers: httpHeaders,
        params: params
      }
    );
  }
  getCompanyByIdpromise(Id: string) {
    var requestUrl = localStorage.getItem("DomainUrl");
    var token = localStorage['token'];
    let locationId = JSON.parse(localStorage['Location'] == undefined ? null : localStorage['Location']);
    let companyid = localStorage['companyId'];
    var ipAddress = localStorage.getItem('IA')
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'X-Forwarded-For': `${ipAddress}`,
      'RequestUrl': requestUrl ? requestUrl : " "
    });
    // let httpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    let params = new HttpParams().set("companyId", companyid).set("locationId", (locationId || {}).id);

    return this._http.get(environment.endPoint + '/api/Company/GetById?id=' + Id,
      {
        headers: httpHeaders,
        params: params
      }
    )
  }

  getAll(Id: string) {
    var requestUrl = localStorage.getItem("DomainUrl");
    var token = localStorage['token'];
    let locationId = JSON.parse(localStorage['Location'] == undefined ? null : localStorage['Location']);
    let companyid = localStorage['companyId'];
    var ipAddress = localStorage.getItem('IA')
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'X-Forwarded-For': `${ipAddress}`,
      'RequestUrl': requestUrl ? requestUrl : " "
    });
    // let httpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token, );
    let params = new HttpParams().set("companyId", companyid).set("locationId", (locationId || {}).id);

    return this._http.get(environment.endPoint + '/api/GeneralSetting/GetAll?id=' + Id,
      {
        headers: httpHeaders,
        params: params
      }
    )
  }
  matchEmailName(Email: any) {
    let model = { Email: Email }
    return this._http.post(
      `${environment.endPoint}/api/Company/CheckEmailExists`,
      model
    );
  }

  updateStatus(compnayId: any, StatusName: any) {
    return this._http.post(
      `${environment.endPoint}/api/Company/UpdateStatus?compnayId=${compnayId}&StatusName=${StatusName}`, "");
  }
  getAllError(state: DataSourceRequestState, SearchText: any) {
    var queryStr = `${toDataSourceRequestString(state)}`;
    return this._http.get<any>(`${environment.endPoint}/api/ELMAH_Error/GetAll?${queryStr}&SearchText=${SearchText}`);
  }

  getAllLoginLog(state: DataSourceRequestState, SearchText: any, StartDate: any, EndDate: any) {
    var queryStr = `${toDataSourceRequestString(state)}`;
    return this._http.get<any>(`${environment.endPoint}/api/LoginLogs/GetLoginlog?${queryStr}&SearchText=${SearchText}&StartDate=${StartDate}&EndDate=${EndDate}`);
  }
  GetDeviceCount() {
    return this._http.get<any>(`${environment.endPoint}/api/LoginLogs/GetDeviceCount`);
  }

  getIPAddress() {
    return this._http.get("https://api64.ipify.org?format=json");
  }

  getIPLocation() {
    return this._http.get("https://ipinfo.io/json");
  }
  // getAllError(state: DataSourceRequestState, errorFilterViewModel: any = {}) {
  //   return this._http.post(
  //     `${environment.endPoint}/GetAll?${toDataSourceRequestString(
  //       state
  //     )}`,
  //     errorFilterViewModel
  //   );
  // }
  getByIdError(id: any) {
    return this._http.get<any>(`${environment.endPoint}/api/ELMAH_Error/GetById?id=${id}`);
  }
  sendAnnouncementEmailforAdmin(adminEmailDto: any) {
    return this._http.post(
      `${environment.endPoint}/api/Company/SendAnnouncementEmailforAdmin`,
      adminEmailDto
    );
  }

  adminEmailTemplate(adminEmailTemplateDto: any) {
    return this._http.post(
      `${environment.endPoint}/api/AdminEmailTemplate/Create`,
      adminEmailTemplateDto
    );
  }

  getTemplate() {
    return this._http.get<any>(`${environment.endPoint}/api/AdminEmailTemplate/GetTemplate`);
  }

  getTemplateById(Id: any) {
    return this._http.get<any>(`${environment.endPoint}/api/AdminEmailTemplate/Get?id=${Id}`);
  }

  DeleteTemplate(data: any) {
    return this._http.put(`${environment.endPoint}/api/AdminEmailTemplate/Delete`, data);
  }
  getMaintenance() {
    return this._http.get<any>(`${environment.endPoint}/api/UserMessage/Get`);
  }
  updateMaintenance(data: any) {
    return this._http.put(`${environment.endPoint}/api/UserMessage/Update`, data);
  }
  getCountry() {
    return this._http.get<any>(
      `${environment.endPoint}/api/Currency/Get`
    );
  }
  GetTransactionZeroAmount() {
    return this._http.get<any>(`${environment.endPoint}/api/Transactions/GetTransactionZeroAmount`)
  }

  GetTransactionBigAmount(state: DataSourceRequestState, SearchText: any) {
    SearchText = (!SearchText || SearchText.trim() === "") ? " " : SearchText;
    const queryStr = `${toDataSourceRequestString(state)}`;
    return this._http.get<any>(`${environment.endPoint}/api/Transactions/GetTransactionBigAmount?${queryStr}&SearchText=${SearchText}`);
  }

  GetPlusPhysioDomain(state: DataSourceRequestState, SearchText: any) {
    SearchText = (!SearchText || SearchText.trim() === "") ? " " : SearchText;
    const queryStr = `${toDataSourceRequestString(state)}`;
    return this._http.get<any>(`${environment.endPoint}/api/Company/GetPlusPhysioDomain?${queryStr}&SearchText=${SearchText}`);
  }

  GetPlusDoctorDomain(state: DataSourceRequestState, SearchText: any) {
    SearchText = (!SearchText || SearchText.trim() === "") ? " " : SearchText;
    const queryStr = `${toDataSourceRequestString(state)}`;
    return this._http.get<any>(`${environment.endPoint}/api/Company/GetPlusDoctorDomain?${queryStr}&SearchText=${SearchText}`);
  }

  GetActiveAndNonActiveCountPhysio() {
    return this._http.get<any>(`${environment.endPoint}/api/Company/GetActiveAndNonActiveCountPhysio`);
  }
  GetActiveAndNonActiveCountPlusDoctor() {
    return this._http.get<any>(`${environment.endPoint}/api/Company/GetActiveAndNonActiveCountPlusDoctor`);
  }
  AdminGridSettingAddData(data: any) {
    return this._http.post(
      `${environment.endPoint}/api/AdminGridSetting/Create`,
      data
    );
  }
  GetDomainName(DomainName: any, TableName: any) {
    return this._http.get(
      `${environment.endPoint}/api/AdminGridSetting/GetDomainName?DomainName=${DomainName}&TableName=${TableName}`
    );
  }

  createAddOnDetails(data: any[]) {
    return this._http.post(
      `${environment.endPoint}/api/AddOnDetails/CreateAddOnDetails`,
      data
    );
  }

  getActiveAddOnDetails(companyId: number) {
    return this._http.get<any>(`${environment.endPoint}/api/AddOnDetails/GetByCompanyId?companyId=${companyId}`);
  }

  getAddOnDetails(companyId: number) {
    return this._http.get<any>(`${environment.endPoint}/api/AddOnDetails/GetAllByCompanyId?companyId=${companyId}`);
  }

  AddTransactionDetails(stripePaymentModel: any) {
    return this._http.post(`${environment.endPoint}/api/Payment/AddTransactionDetails`, stripePaymentModel);
  }

  addMasterMigration() {
    return this._http.post(`${environment.endPoint}/api/Admin/AdminMasterMigration`, null);
  }

  logoutAllUsers(companyId: number) {
    return this._http.post(`${environment.endPoint}/api/Admin/ForceLogoutAllUsers?companyId=${companyId}`, {});
  }

  getLocations(companyId: number) {
    return this._http.get<any>(
      `${environment.endPoint}/api/Company/GetCompanyLocations?companyId=${companyId}`
    );
  }

  enableWhatsappInstance(data: any) {
    return this._http.post(`${environment.endPoint}/api/Company/EnableWhatsapp`, data);
  }

  resetPassword(data: any) {
    return this._http.post(`${environment.endPoint}/api/Company/ResetPassword`, data);
  }

  updatePlanLimit(model: any) {
    return this._http.post(`${environment.endPoint}/api/PlanLimit/UpdatePlanLimit`, model);
  }

  getPlanLimit(companyId: number) {
    return this._http.get<any>(`${environment.endPoint}/api/PlanLimit/GetPlanLimits?companyId=${companyId}`);
  }

  cancelAutoRenew(subscriptionId: string) {
    return this._http.post(`${environment.endPoint}/api/Payment/CancelSubscription?subscriptionId=${subscriptionId}`, {});
  }

  getSubscriptionDetails(companyId?: number) {
    return this._http.get<any>(`${environment.endPoint}/api/Transactions/GetByTransactionAllCompanyId?companyId=${companyId}`);
  }

  getGeneralSetting(companyId: number, key: string) {
    return this._http.get(
      `${environment.endPoint}/api/GeneralSetting/GetByDomain?companyId=${companyId}&key=${key}`
    );
  }

  updateGeneralSettingByDomain(companyId: number, data: any) {
    return this._http.post(
      `${environment.endPoint}/api/GeneralSetting/UpdateByDomain?companyId=${companyId}`,
      data
    );
  }
}
